import type { ReactNode } from 'react';

export interface VideoProps {
  /**
   * Platform of the video
   */
  videoPlatform: 'brightcove' | 'vimeo' | 'youtube';

  /**
   * ID of the video
   */
  videoID: string;

  /**
   * Account ID of the video for Brightcove
   */
  brightcoveAccountId?: string;

  /**
   * Caption for the video container
   */
  caption?: ReactNode;

  /**
   * Class names to apply to the video container
   */
  classNames?: string;

  /**
   * Test ID used for testing
   */
  testid?: string;
}

/**
 * Determines if the props match VideoProps. See also, isImage in Image.types
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isVideo = (props: VideoProps | any): props is VideoProps =>
  'videoID' in props;
